<template>
    <DModal
        :title="__('customers.contracts.product_change.title')"
        :show="showModal"
        is-error
        is-confirm
        is-awaiting-validation
        @close="$emit('close-modal')"
        @confirm="confirmUpdateProduct()"
    >
        <DFieldLoading
            v-if="isLoading"
            :is-loading="isLoading"
            is-big
            class="my-4 d-flex justify-content-center"
        />
        <div
            v-else
            style="padding: 20px;"
        >
            <div class="table-padding">
                <h4>
                    {{ __('customers.contracts.product_change.subtitle_current') }}
                </h4>
                <div style="padding-left: 40px">
                    <DForm @submit.prevent="">
                        <DFormRow
                            :label="__('customers.contracts.product_change.label_product')"
                            :is-required="false"
                            :style="{ marginBottom: 0}"
                        >
                            <Link :href="viewProductUrl">
                                {{ contract.active_contract_phase.product.name }}
                            </Link>
                        </DFormRow>
                        <DFormRow
                            :label="__('customers.contracts.product_change.label_account')"
                            :is-required="false"
                        >
                            <Link
                                v-if="contract.fulfillment_account_id !== null"
                                :href="viewAccountUrl"
                            >
                                {{ contract.fulfillment_account.name }}
                            </Link>
                            <span v-else>{{ __('customers.contracts.product_change.fulfillment_account_missing') }}</span>
                        </DFormRow>
                    </DForm>
                </div>
            </div>
            <div class="table-padding">
                <h4>
                    {{ __('customers.contracts.product_change.subtitle_new') }}
                </h4>
                <div style="padding-left: 40px">
                    <DForm @submit.prevent="">
                        <DFormRow
                            :label="__('customers.contracts.product_change.label_product')"
                            :is-required="true"
                        >
                            <DSelect
                                id="product_id"
                                v-model="changeProductForm.product_id"
                                :options="productOptions"
                                :placeholder="__('customers.contracts.product_change.product_choose')"
                            />
                            <p
                                v-if="errors.product_id"
                                class="help-block text-danger"
                            >
                                {{ errors.product_id }}
                            </p>
                        </DFormRow>
                    </DForm>
                </div>
            </div>
            <div class="table-padding mt-4">
                <p>{{ __('customers.contracts.product_change.warning') }}</p>
            </div>
        </div>
    </DModal>
</template>

<script>

import DFieldLoading from '~@/Components/Common/DFieldLoading'

export default {
    name: 'ProductChangeModal',
    components: { DFieldLoading },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        contract: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal'],
    data () {
        return {
            errors: {},
            changeProductForm: this.$inertia.form({
                product_id: null
            }),
            isLoading: true,
            products: []
        }
    },
    computed: {
        viewProductUrl () {
            return this.$route('products.products.show', {
                product: this.contract.active_contract_phase.product.id
            })
        },
        viewAccountUrl () {
            return this.$route('products.accounts.show', {
                account: this.contract.fulfillment_account_id
            })
        },
        productOptions () {
            return this.products.map((item) => {
                return { value: item.id, label: `${item.name} (${item.id})` }
            })
        }
    },
    created () {
        window.axios.get(this.$route('customers.customers.contracts.change-product-options', {
            customer: this.customer.id,
            contract: this.contract.id
        }))
            .then(response => {
                this.products = response.data.products
                this.isLoading = false
            })
    },
    methods: {
        confirmUpdateProduct () {
            this.changeProductForm.post(this.$route('customers.customers.contracts.products-change', {
                customer: this.customer.id,
                contract: this.contract.id
            }), {
                onSuccess: () => {
                    this.$emit('close-modal')
                    this.resetChangeProductForm()
                },
                onError: (error) => {
                    this.errors = error
                }
            })
        },
        resetChangeProductForm () {
            this.changeProductForm.product_id = null
            this.errors = {}
        }
    }
}
</script>
